import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"info\"><path fill-rule=\"evenodd\" d=\"M6.5 7.5C6.5 5.57 8.07 4 10 4s3.5 1.57 3.5 3.5c0 1.58-1.06 2.903-2.5 3.337V12a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1c.827 0 1.5-.673 1.5-1.5S10.827 6 10 6s-1.5.673-1.5 1.5a1 1 0 1 1-2 0M9 15a1 1 0 1 1 2 0 1 1 0 1 1-2 0m1 3c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-18C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol